// Note: the *initial* theme is set synchronously by a small inline script
// in the <head> (see _includes/partials/head.njk) so there is no flash of
// the wrong theme before this module loads. This module only wires the
// toggle button and keeps localStorage in sync after that.
const STORAGE_KEY = "abhilash-theme";

export function initTheme() {
  const root = document.documentElement;
  const toggle = document.querySelector("[data-theme-toggle]");

  toggle?.setAttribute("aria-pressed", String(root.getAttribute("data-theme") === "light"));

  toggle?.addEventListener("click", () => {
    const next = root.getAttribute("data-theme") === "light" ? "dark" : "light";
    root.setAttribute("data-theme", next);
    toggle.setAttribute("aria-pressed", String(next === "light"));
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* storage unavailable — theme just won't persist */
    }
  });
}
